import apiClient from "./apiClient";

export function listUsersRequest(params = {}) {
  return apiClient.get("/users", { params });
}

export function getUserRequest(userId) {
  return apiClient.get(`/users/${userId}`);
}

export function createUserRequest(payload) {
  return apiClient.post("/users", payload);
}

export function updateUserRequest(userId, payload) {
  return apiClient.patch(`/users/${userId}`, payload);
}

export function deleteUserRequest(userId) {
  return apiClient.delete(`/users/${userId}`);
}
